<template>
    <div class="card mb-0" v-show="ratingOptions && sortedCompetencies && simulations">
        <el-table class="table-responsive table-flush"
                header-row-class-name="thead-light"
                :data="sortedCompetencies">

            <el-table-column width="200">
                <template v-slot="{row}">
                    <h4 class="mb-0">
                        {{ competencyName(row) }}
                    </h4>
                    <div v-if="row.domain">
                        <badge rounded :type="row.domain.color" class="mt-1">
                            {{ competencyDomainName(row) }}
                        </badge>
                    </div>
                </template>
            </el-table-column>

            <el-table-column v-for="(simulation, index) in realSimulations" :key="index"
                align="center" header-align="center"
                class-name="session" width="50"
            >
                <a slot="header" href="#" @click.prevent="openSimulation(simulation)"
                    v-if="$permissions.hasRight('dashboard.sessions.read') && (simulation.state.published || $permissions.hasRight('dashboard.learners.write'))">
                    {{ simulation.name }}
                </a>

                <span slot="header" v-else>
                    {{ simulation.name }}
                </span>

                <template v-slot="{row}">
                    <rating v-if="simulation.state.published && simulation.state.competencies && simulation.state.competencies[simulationRole]"
                        :name="competencyName(row)"
                        :description="competencyDescription(row)"
                        :value="simulation.state.competencies[simulationRole][row.id]"
                        :options="ratingOptions"
                        :comment="competencyComment(simulation.state, simulationRole, row.id)"
                    >
                    </rating>
                </template>

            </el-table-column>
            
            <el-table-column label="">
            </el-table-column>
            
        </el-table>
    </div>
</template>

<script>
    import Rating from './Rating'

    export default {

        components: {
            Rating
        },

        props: {

            num: {
                type: Number,
            },

            simulations: {
                type: Array,
            },

            competencies: {
                type: Object,
            },

            position1Competencies: {
                type: Object,
            },

            position2Competencies: {
                type: Object,
            },

            registration: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
            },
        },
        
        data() {
            return {
                pinned: this.$auth.getUiConfig('pinned_simulation_in_registration_' + this.registration.id),
            }
        },

        created() {
            this.$eventBus.$on('simulation_pinned', pinned => {
                this.pinned = pinned;
            })
        },

        computed: {

            realSimulations() {
                let pinnedSimulations = this.simulations;
                if (this.pinned) {
                    let visible = false;
                    pinnedSimulations = [];
                    for (const simulation of this.simulations) {
                        if (simulation.id == this.pinned) {
                            visible = true;
                        }
                        if (visible) {
                            pinnedSimulations.push(simulation)
                        }
                    }
                }
                return pinnedSimulations.filter(sim => !sim.assessment)
            },

            simulationRole() {
                return this.registration.degree['simulation_role_' + this.num]
            },

            sortedCompetencies() {
                return Object.values(this['position' + this.num + 'Competencies'])
                    .map(competency => this.competencies[competency.id])
                    .sort((a, b) => a.position - b.position)
            },
        },

        methods: {

            competencyName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency[nameProp]
            },

            competencyDescription(competency) {
                const posCompetency = this['position' + this.num + 'Competencies'][competency.id]
                if (!posCompetency) {
                    return ''
                }
                return posCompetency.pivot.description
            },

            competencyDomainName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency.domain[nameProp]
            },

            competencyComment(state, simulationRole, id) {
                return state.competency_comments && state.competency_comments[simulationRole]
                    ? state.competency_comments[simulationRole][id]
                    : null
            },

            openSimulation(simulation) {
                let routeName = simulation.state.published 
                    ? 'dashboard-learner-simulation'
                    : 'dashboard-learner-simulation-edit'

                this.$router.push({
                    name: routeName,
                    params: {
                        learnerId: this.$route.params.learnerId,
                        registrationId: this.$route.params.registrationId,
                        simulationId: simulation.id,
                    }
                });
            }
        }
    }
</script>

<style scoped>

    .card >>> .el-table__body-wrapper {
        padding-bottom: 5px;
    }
    .card >>> .el-table th.session .cell {
        justify-content: center;
        line-height: 1rem;
        padding: 0.7rem 0;
    }
    .card >>> .el-table th.session .cell a:hover {
        color: #233dd2;
    }
    .card >>> .el-table .session {
        padding-left: 0;
        padding-right: 0;
        max-width: 70px;
    }
    
</style>
